import { failureResponse } from './responseUtils';
import { UNHANDLED_ERROR } from 'src/constants/errors';
import { AlertColor } from '@mui/material';
import { formatApiErrorMessage, getApiErrorDetails } from './apiErrorUtils';

export async function handleError(error: unknown) {
  const { message, statusCode, errorCode, upgradeOffer } =
    getApiErrorDetails(error);

  return failureResponse(
    message ?? UNHANDLED_ERROR,
    statusCode,
    errorCode,
    upgradeOffer,
  );
}

export const DUPLICATION_API_RESPONSE_ERROR_MESSAGE =
  'I am sorry, but it seems the provided data already exist';

export async function notifyUnhandledError(
  error: unknown,
  notify: (message: string, severity: AlertColor) => void,
) {
  const { message, statusCode } = await handleError(error);

  notify(
    formatApiErrorMessage(message ?? UNHANDLED_ERROR, statusCode),
    'error',
  );
}
